export const address = {
  address: '123 Test St',
  city: 'Austin',
  state: 'TX',
  postal: '78721',
  country: 'US',
  fname: 'Oura',
  lname: 'Test',
};
